module.exports = __webpack_public_path__ + "img/close.4048bab0.svg";